import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import { LOADING_SCREEN_ZINDEX } from '@/constants/zindex';
import { mq } from '@/utils/mediaQuery';

const spinning = () => keyframes`
  from { transform: rotate(0) }

  to { transform: rotate(360deg) }
`;

export const LoadingSpinnerSvg = styled.svg`
  animation: ${spinning} 1s ease infinite;
`;

export const LoadingScreenContainer = styled.div(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.color.white,
  width: '100%',
  minWidth: '100vw',
  height: '100vh',
  maxHeight: '100vh',
  zIndex: LOADING_SCREEN_ZINDEX,
  color: 'white',
  overflow: 'hidden',

  '& > div': {
    opacity: 1,
    position: 'absolute',
    transition: 'all 0.1s',
    width: '100%',
    height: '100%',
    animationTimingFunction: 'ease',
    animationFillMode: 'both',
    animationDuration: '1s',
  },
}));

export const LoadingPhasePurple = styled.div(({ theme }) => ({
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5rem 0',
  background: theme.color.base_purple,
}));

export const LoadingLogo = styled.object(() => ({
  width: '24rem',

  [mq('desktop')]: {
    width: '35rem',
  },
}));
